// Edge Functions URL helper
// Centralizes Supabase Edge Function URLs to avoid hardcoding

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

export const edgeFunctionUrl = (functionName: string): string => {
  if (!SUPABASE_URL) {
    throw new Error('REACT_APP_SUPABASE_URL environment variable is not set');
  }
  return `${SUPABASE_URL}/functions/v1/${functionName}`;
};

// Available Edge Functions
export const EdgeFunctions = {
  CREATE_PAYMENT_INTENT: 'create-payment-intent',
  CONFIRM_PAYMENT: 'confirm-payment',
  CREATE_SUBSCRIPTION: 'create-subscription',
  CREATE_CHECKOUT_SESSION: 'create-checkout-session',
  CREATE_TERMINAL_PAYMENT_INTENT: 'create-terminal-payment-intent',
  CREATE_CONNECTION_TOKEN: 'create-connection-token',
  CREATE_TIP_PAYMENT: 'create-tip-payment',
  CONFIRM_TIP_PAYMENT: 'confirm-tip-payment',
  STRIPE_WEBHOOK: 'stripe-webhook',
  STRIPE_MEMBERSHIP_WEBHOOK: 'stripe-membership-webhook',
  SEND_BOOKING_CONFIRMATION: 'send-booking-confirmation',
  SEND_CONTACT_FORM: 'send-contact-form',
  // Wallet functions
  CREATE_WALLET_TOPUP: 'create-wallet-topup',
  CONFIRM_WALLET_TOPUP: 'confirm-wallet-topup',
  USE_WALLET_PAYMENT: 'use-wallet-payment',
} as const;
